import React from "react";
import { Scale } from "lucide-react";
import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

/**
 * Admin variant of AuthCard — same layout but with a red ADMIN badge under the logo.
 */
const AdminAuthCard = ({ children, className }) => {
  return (
    <div
      data-testid="admin-auth-shell"
      className="min-h-screen w-full flex items-center justify-center bg-bg-primary px-4 py-10"
      style={{
        backgroundImage:
          "radial-gradient(1200px 500px at 15% -10%, rgba(231,76,60,0.10), transparent 60%), radial-gradient(900px 400px at 105% 110%, rgba(231,76,60,0.06), transparent 60%)",
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.25, ease: [0.4, 0, 0.2, 1] }}
        className={cn(
          "w-full max-w-[400px] bg-bg-secondary border border-danger/30 rounded-[16px] p-12 shadow-elevated",
          className
        )}
      >
        <div className="flex items-center justify-center gap-2 mb-3">
          <Scale className="text-accent-pink" size={22} strokeWidth={2.5} />
          <span className="font-extrabold text-[18px] text-accent-pink tracking-tight">
            Judgment Enforcement AI
          </span>
        </div>
        <div className="flex justify-center mb-6">
          <span
            className="inline-flex items-center px-3 py-1 rounded-[4px] border border-danger text-danger text-[11px] font-bold tracking-[0.10em]"
            data-testid="admin-badge"
          >
            ADMIN
          </span>
        </div>
        <div className="h-px w-full bg-danger/20 mb-6" />
        {children}
      </motion.div>
    </div>
  );
};

export default AdminAuthCard;
